package com.exura.components.snackbar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.exura.surface
import com.exura.ui.*
import com.varabyte.kobweb.compose.css.BoxShadow.Companion.of
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.overlay
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.Position

@Composable
internal fun Snackbar(
    snackbarMessage: SnackbarMessage,
) {
    var visible by remember { mutableStateOf(false) }

    LaunchedEffect(snackbarMessage) {
        visible = true
        delay(timeMillis = Durations.SNACK_MESSAGE_LIFETIME_MS)
        visible = false
    }

    if (visible) {
        Box(
            modifier = SnackbarStyle.toModifier(),
        ) {
            SpanText(snackbarMessage.message)
        }
    }
}

sealed interface SnackbarKind : ComponentKind

val SnackbarStyle = CssStyle<SnackbarKind> {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .position(Position.Fixed)
            .left(Dimens.snackbarPositionLeft)
            .bottom(Dimens.snackbarPositionBottom)
            .padding(leftRight = Dimens.snackbarIndent, topBottom = Dimens.snackbarWrapping)
            .backgroundColor(palette.overlay.lightened())
            .color(palette.color)
            .borderRadius(Dimens.snackbarBorderRadius)
            .boxShadow(
                of(
                    color = palette.surface,
                    blurRadius = Dimens.snackbarShadowRadius,
                )
            )
            .fontSize(Dimens.snackbarFontSize)
            .zIndex(105)
    }
}
